import { defineProperty as _defineProperty, inherits as _inherits, createClass as _createClass, classCallCheck as _classCallCheck, callSuper as _callSuper } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { Component } from 'react';
import PropTypes from 'prop-types';

var SelectionModalButton = /*#__PURE__*/function (_Component) {
  function SelectionModalButton() {
    _classCallCheck(this, SelectionModalButton);

    return _callSuper(this, SelectionModalButton, arguments);
  }

  _inherits(SelectionModalButton, _Component);

  return _createClass(SelectionModalButton, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          onClick = _this$props.onClick,
          selected = _this$props.selected,
          iconSrc = _this$props.iconSrc,
          title = _this$props.title;
      return /*#__PURE__*/React.createElement("div", {
        className: "selection-modal-button ".concat(selected && ' selected'),
        onClick: onClick
      }, iconSrc && /*#__PURE__*/React.createElement("div", {
        className: "select-modal-icon"
      }, /*#__PURE__*/React.createElement("img", {
        src: iconSrc
      })), /*#__PURE__*/React.createElement("div", {
        className: "select-modal-description"
      }, title && /*#__PURE__*/React.createElement("h3", {
        className: "select-modal-title"
      }, title), this.props.children));
    }
  }]);
}(Component);

_defineProperty(SelectionModalButton, "propTypes", {
  iconSrc: PropTypes.string,
  children: PropTypes.any,
  title: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  selected: PropTypes.bool
});

SelectionModalButton.displayName = "SelectionModalButton";
export { SelectionModalButton };